import React, {useCallback, useState} from "react";
import {OfferFileResponse} from "../../../../Api/data/offer/types";
import {useKeycloak} from "@react-keycloak/web";
import {deleteOfferAttachment, getAllOfferAttachments} from "../../../../Api/data/offer/client";
import CrudList, {
    CrudListConfiguration,
    ICrudListProps,
    SelectMode
} from "../../../../Crudder/components/CrudList/CrudList";
import {dateFormatter, dateTimeFormatter, fileSizeFormatter} from "../../../../Crudder/utils/utils";
import {downloadFile} from "../../../../Api/data/file/client";
import {Link} from "@material-ui/core";
import Button from "@mui/material/Button";



interface IOfferFileListProps {
    offerID: number;
    crudListProps?: Partial<CrudListConfiguration<OfferFileResponse>>
}

const OfferFileList: React.FC<IOfferFileListProps> = ({offerID, crudListProps}) => {

    const [ data, setData ] = useState<OfferFileResponse[]>([]);


    const { keycloak, initialized: keycloakInitialized } = useKeycloak();

    const fetchData = useCallback(() => {
        return new Promise<OfferFileResponse[]>((resolve, reject) => {
            getAllOfferAttachments(offerID).then((data) => {
                setData(data);
                resolve(data)
            })
        });
    }, []);

    const handleDelete: (values: number) => Promise<void> = useCallback((id: number) => {
        return new Promise<void>((resolve, reject) => {
            deleteOfferAttachment(offerID, id).then((response) => {
                resolve();
            })
        });
    }, []);
    //
    // const getDetail = useCallback((id) => {
    //     return new Promise<any>((resolve, reject) => {
    //         resolve(data.find(i => i.offerID == id));
    //     });
    // }, [data]);


    return (
            <CrudList<OfferFileResponse>
                config={{
                    title: "Seznam souborů",
                    getRowID: (file) => file.offerFileID,
                    disableAdd: true,
                    hideHeader: true,
                    disableEdit: crudListProps?.disableEdit || crudListProps?.selectMode != SelectMode.NONE,
                    disableRemove: crudListProps?.disableRemove || crudListProps?.selectMode != SelectMode.NONE,
                    selectMode: crudListProps?.selectMode,
                    ...crudListProps
                }}
                itemFields={[
                    {
                        name: "name",
                        title: "Název",
                        columnDef: {
                            flex: 4,
                            renderCell: params => {
                                // params.row.
                                return (
                                    <Link component={Button} color={"inherit"} onClick={() => {
                                        downloadFile(params.row.fileID);
                                    }}>
                                        {params.value}
                                    </Link>
                                )
                            }
                        },
                    },
                    {
                        name: "createdDate",
                        title: "Vytvořeno",
                        columnDef: {
                            flex: 1,
                            valueFormatter: dateTimeFormatter
                        },
                    },
                    {
                        name: "size",
                        title: "Velikost",
                        columnDef: {
                            flex: 1,
                            valueFormatter: fileSizeFormatter
                        },
                    },
                    {
                        name: "mimeType",
                        title: "Typ",
                        columnDef: {
                            hide: true,
                            flex: 2
                        },
                    },
                ]}
                data={fetchData}
                onDelete={handleDelete}
            />
    );
};

export default OfferFileList;